import React from "react";
import { Popover, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CommonPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  sx?: object;
  slotProps?: object;
  showCloseIcon?: boolean;
}

const CommonPopover: React.FC<CommonPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  title,
  children,
  sx = {},
  slotProps = {},
  showCloseIcon = true,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            overflow: "visible",
            borderRadius: "8px",
            borderTopLeftRadius: 3,
            paddingX: 0,
            paddingY: 0,
            maxWidth: 300,
            ml: 10,
            mt: "20px",
            boxShadow: "3px 3px 5px 2px rgba(0,0,0,0.1)",
            "&:after,&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 8,
              left: -9,
              width: 18,
              height: 18,
              backgroundColor: "white",
              transform: "rotate(45deg)",
              boxShadow: "-3px 3px 5px -2px rgba(0,0,0,0.1)",
            },
            ...sx,
          },
          ...slotProps,
        },
      }}
    >
      {/* {(title || showCloseIcon) && (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1 }}>
          {title && (
            <Typography variant="subtitle1" fontWeight={500} fontSize={16} sx={{ color: "#3B3B3B" }}>
              {title}
            </Typography>
          )}
          {showCloseIcon && (
            <IconButton size="small" aria-label="close" onClick={onClose} sx={{ padding: 0, color: "#3B3B3B" }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      )} */}
      <Box sx={{ p: 1 }}>{children}</Box>
    </Popover>
  );
};

export default CommonPopover; 